import DateTimeRangePicker from "./DateTimeRangePickerIndex"

export default { DateTimeRangePicker } 
